import { render, staticRenderFns } from "./OccurrenceDetailModal.vue?vue&type=template&id=c28a9942&scoped=true&"
import script from "./OccurrenceDetailModal.vue?vue&type=script&lang=js&"
export * from "./OccurrenceDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceDetailModal.vue?vue&type=style&index=0&id=c28a9942&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28a9942",
  null
  
)

export default component.exports